import React from "react";
import { Modal, Button } from "react-bootstrap";
import Stopaddmap from "./Stopaddmap";
import { useState, useEffect } from "react";
const Addstopmodal = ({
  modalVisible,
  setModalVisible,
  onsubmit,
  isAddSubmiting,
  lat = "",
  lng = "",
  name = "",
  title = "",
}) => {
  const [markerPosition, setMarkerPosition] = useState(null);
  useEffect(() => {
    if (modalVisible) {
      // Only set if lat/lng are available and marker isn't already set
      if (name) {
        setAddFormFields((prev) => ({
          ...prev,
          name: name,
        }));
      }
      if (lat && lng && !markerPosition) {
        setMarkerPosition({ lat: parseFloat(lat), lng: parseFloat(lng) });
        setAddFormFields((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));
      }
    } else {
      setAddFormFields({
        name: "",
        longitude: "",
        latitude: "",
      });
      seterrorFormFields({
        name: "",
        longitude: "",
        latitude: "",
      });
      setMarkerPosition(null);
    }
  }, [modalVisible, lat, lng, name]);

  useEffect(() => {
    setAddFormFields({
      ...addFormFields,
      longitude: markerPosition?.lng || "",
      latitude: markerPosition?.lat || "",
    });
    if (markerPosition?.lat && markerPosition?.lng) {
      seterrorFormFields({ ...adderrorFields, latitude: "", longitude: "" });
    }
  }, [markerPosition]);
  const [addFormFields, setAddFormFields] = useState({
    name: "",
    longitude: "",
    latitude: "",
  });
  const [adderrorFields, seterrorFormFields] = useState({
    name: "",
    longitude: "",
    latitude: "",
  });
  const handleToggleModal = () => {
    if (!modalVisible) {
      setAddFormFields({
        name: "",
        longitude: "",
        latitude: "",
      });
      seterrorFormFields({
        name: "",
        longitude: "",
        latitude: "",
      });
      setMarkerPosition(null);
    }
    setModalVisible((prev) => !prev);
  };

  const handleSubmit = () => {
    console.log(markerPosition);
    let valid = true;
    const error = { name: "", longitude: "", latitude: "" };
    if (!addFormFields?.name) {
      error.name = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields?.longitude) {
      error.longitude = "Mandatory Field";
      valid = false;
    }
    if (!addFormFields?.latitude) {
      error.latitude = "Mandatory Field";
      valid = false;
    }
    seterrorFormFields(error);
    if (valid) {
      onsubmit(addFormFields);
    }
  };
  return (
    <div>
      <Modal
        show={modalVisible}
        onHide={handleToggleModal}
        centered
        className="custom-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="py-4">
          {(adderrorFields?.latitude || adderrorFields?.longitude) && (
            <div className="alert alert-danger">
              Select stop position on the map
            </div>
          )}
          <div className="filter-sections">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Stop Name
              </label>
              <input
                type="text"
                className={`form-control ${
                  adderrorFields?.name ? "is-invalid" : ""
                }`}
                id="name"
                placeholder="Enter Stop Name"
                value={addFormFields.name}
                onChange={(e) => {
                  setAddFormFields({ ...addFormFields, name: e.target.value });
                  if (e.target.value) {
                    seterrorFormFields({...adderrorFields,name:''})
                  }
                }}
              />
            </div>
            {/* <div className="d-flex justify-content-between gap-3 align-items-center">
                <div className="mb-3 w-100">
                  <label htmlFor="latitude" className="form-label">
                    Latitude
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="latitude"
                    placeholder="Enter Latitude"
                    value={addFormFields.latitude}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        latitude: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="mb-3 w-100">
                  <label htmlFor="longitude" className="form-label">
                    Longitude
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="longitude"
                    placeholder="Enter Longitude"
                    value={addFormFields.longitude}
                    onChange={(e) =>
                      setAddFormFields({
                        ...addFormFields,
                        longitude: e.target.value,
                      })
                    }
                  />
                </div>
              </div> */}
            <div>
              <Stopaddmap
                markerPosition={markerPosition}
                setMarkerPosition={setMarkerPosition}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outline-secondary"
            disabled={isAddSubmiting}
            onClick={handleToggleModal}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            disabled={isAddSubmiting}
            onClick={handleSubmit}
          >
            Create
            {isAddSubmiting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Addstopmodal;
